module.exports = __webpack_public_path__ + "media/images/school_hayawari-5c12641423c908be4414a7dafc7fc70e.png";